export interface WalletNetwork {
  id: string
  label: string
  confirmations: number
  minDeposit: string
  feeHint: string
}

export interface WalletAsset {
  id: string
  symbol: string
  name: string
  balance: number
  networks: WalletNetwork[]
  /** Demo deposit addresses per network id */
  addresses: Record<string, string>
}

export const WALLET_ASSETS: WalletAsset[] = [
  {
    id: 'usdt',
    symbol: 'USDT',
    name: 'Tether',
    balance: 12_480.55,
    networks: [
      {
        id: 'trc20',
        label: 'TRC20',
        confirmations: 1,
        minDeposit: '10',
        feeHint: '~1 USDT',
      },
      {
        id: 'erc20',
        label: 'ERC20',
        confirmations: 12,
        minDeposit: '20',
        feeHint: '~3–8 USDT',
      },
      {
        id: 'bep20',
        label: 'BEP20',
        confirmations: 15,
        minDeposit: '10',
        feeHint: '~0.5 USDT',
      },
    ],
    addresses: {
      trc20: 'TXk9mQpLwR7vN2hY4cF8dA6sB1eG3jU5zW',
      erc20: '0x71C7656EC7ab88b098defB751B7401B5f6d8976F',
      bep20: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    },
  },
  {
    id: 'btc',
    symbol: 'BTC',
    name: 'Bitcoin',
    balance: 0.1842,
    networks: [
      {
        id: 'bitcoin',
        label: 'Bitcoin',
        confirmations: 2,
        minDeposit: '0.0002',
        feeHint: 'Network fee',
      },
    ],
    addresses: {
      bitcoin: 'bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh',
    },
  },
  {
    id: 'eth',
    symbol: 'ETH',
    name: 'Ethereum',
    balance: 2.451,
    networks: [
      {
        id: 'erc20',
        label: 'ERC20',
        confirmations: 12,
        minDeposit: '0.01',
        feeHint: '~0.002 ETH',
      },
    ],
    addresses: {
      erc20: '0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb0',
    },
  },
]
